import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.posSoftware.data?.data?.find((x) => x.id === id);
}
